<div class="ba-wrapper">
  <!-- Loading overlay -->
  @if (isLoading) {
  <div class="ba-loading-overlay">
    <div class="ba-spinner"></div>
  </div>
  }

  <!-- Success screen -->
  @if (success === true) {
  <div class="ba-card ba-card--success">
    <div class="ba-success-icon">&#10003;</div>
    <h2 class="ba-success-title">Appointment Updated!</h2>
    <p class="ba-success-body">
      A confirmation has been sent to <strong>{{ email }}</strong
      >.
    </p>
    <div class="ba-summary">
      <div class="ba-summary__row">
        <span class="ba-summary__label">Date</span>
        <span class="ba-summary__value">{{ formattedDate }}</span>
      </div>
      <div class="ba-summary__row">
        <span class="ba-summary__label">Time</span>
        <span class="ba-summary__value">{{ startTime }}</span>
      </div>
    </div>
  </div>
  }

  <!-- Error screen -->
  @if (success === false) {
  <div class="ba-card ba-card--error">
    <div class="ba-error-icon">&#9888;</div>
    <p class="ba-error-text">{{ errorText || "Something went wrong." }}</p>
  </div>
  }

  <!-- Edit form -->
  @if (!isLoading && success === null) {
  <div class="ba-card">
    <div class="ba-header">
      <p class="ba-header__eyebrow">Reschedule appointment</p>
      <h1 class="ba-header__company">{{ companyName || "Sagel" }}</h1>
    </div>
    <form (ngSubmit)="save()" class="ba-form">
      @if (errorText) {
      <div class="ba-field-error">{{ errorText }}</div>
      }
      <div class="ba-row">
        <div class="ba-field">
          <label class="ba-label"
            >Full name <span class="ba-required">*</span></label
          >
          <input
            class="ba-input"
            type="text"
            [(ngModel)]="name"
            name="name"
            placeholder="Your name"
            required
          />
        </div>
        <div class="ba-field">
          <label class="ba-label"
            >Email <span class="ba-required">*</span></label
          >
          <input
            class="ba-input"
            type="email"
            [(ngModel)]="email"
            name="email"
            placeholder="you@example.com"
            required
          />
        </div>
      </div>
      <div class="ba-row">
        <div class="ba-field">
          <label class="ba-label">Date</label>
          <c-date-picker
            closeOnSelect
            [(ngModel)]="startDate"
            name="startDate"
            locale="en-GB"
            format="dd/MM/yyyy"
            placeholder="Select date"
          >
          </c-date-picker>
        </div>
        <div class="ba-field">
          <label class="ba-label">Time</label>
          <select class="ba-select" [(ngModel)]="startTime" name="startTime">
            @for (t of timeOptions; track t) {
            <option [value]="t">{{ t }}</option>
            }
          </select>
        </div>
      </div>
      <div class="ba-field">
        <label class="ba-label"
          >Phone <span class="ba-optional">(optional)</span></label
        >
        <input
          class="ba-input"
          type="tel"
          [(ngModel)]="phone"
          name="phone"
          placeholder="+1 555 0123"
        />
      </div>
      <div class="ba-field">
        <label class="ba-label"
          >Notes <span class="ba-optional">(optional)</span></label
        >
        <textarea
          class="ba-textarea"
          [(ngModel)]="notes"
          name="notes"
          rows="3"
          placeholder="Additional notes..."
        ></textarea>
      </div>
      <div class="ba-actions">
        <button
          type="submit"
          class="ba-btn ba-btn--primary"
          [disabled]="isSaving"
        >
          @if (isSaving) {
          <span class="ba-spinner ba-spinner--sm"></span>
          }
          {{ isSaving ? "Saving…" : "Save Changes" }}
        </button>
      </div>
    </form>
    <div class="ba-footer">Powered by Sagel</div>
  </div>
  }
</div>
